module.exports = __webpack_public_path__ + "static/media/fond-orange.d51211a2.svg";